<template>
	<div class="table-responsive az_crud_tb nd_table_radius">
		<table class="table" :class="tableClass">
			<thead>
<!--			<slot name="head" v-if="$slots.hasOwnProperty('head')">SLOT: 'head'</slot>-->
			<slot name="head" v-if="$slots.hasOwnProperty('head')"></slot>
			</thead>


			<tbody>
<!--			<slot name="body" v-if="$slots.hasOwnProperty('body')">SLOT: 'body'</slot>-->
			<slot name="body" v-if="$slots.hasOwnProperty('body')"></slot>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'BaseCrudTable',
		props: {
			tableClass: {
				type: [String, Object, Array],
				default: 'miw-700',
			}
		},
	};
</script>
